import { useContext } from 'react'
import { PulseScopeContext } from './pulseScopeContext'

const usePulseScope = (): boolean => useContext(PulseScopeContext)

export default usePulseScope
